import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft, Home } from "lucide-react";
import Button from "@/components/Button";
import useSEO from '@/hooks/useSEO';

const NotFound = () => {
  const location = useLocation();

  // SEO Configuration
  useSEO({
    title: 'Page introuvable - LOOM | Erreur 404',
    description: 'Cette page n\'existe pas ou a été déplacée. Retournez à l\'accueil de LOOM pour découvrir notre communauté Bear.',
    keywords: ['404', 'page introuvable', 'erreur', 'LOOM'],
    type: 'website'
  });
  useEffect(() => {
    // Log 404 for analytics, but remove console.error for production
    if (process.env.NODE_ENV === 'development') {
      console.error(
        "404 Error: User attempted to access non-existent route:",
        location.pathname
      );
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-tan/10 p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-md p-8 text-center">
        <div className="w-16 h-16 bg-brown/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="text-brown text-3xl font-bold">404</span>
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Page Not Found</h1>
        
        <p className="text-gray-600 mb-8">
          We couldn't find the page you're looking for. It might have been moved, deleted, or never existed.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            variant="primary"
            leftIcon={<Home size={18} />}
            onClick={() => window.location.href = '/'}
          >
            Go to Home
          </Button>
          
          <Button
            variant="outline"
            leftIcon={<ArrowLeft size={18} />}
            onClick={() => window.history.back()}
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
